import { jsx as _jsx } from "react/jsx-runtime";
/**
 * 地点级联选择
 * @author 严俊华
 */
import { Cascader } from 'antd';
const CascaderPosition = ({ value = [], addressData = [], disabled = false, loadCascaderData = () => { }, cascaderOnChange = () => { }, }) => {
    return (_jsx(Cascader, { disabled: disabled, value: value, options: addressData, fieldNames: { label: 'name', value: 'code', children: 'children' }, placeholder: "\u8BF7\u9009\u62E9", getPopupContainer: (triggerNode) => {
            return triggerNode.parentNode || document.body;
        }, loadData: (v) => loadCascaderData(v), onChange: cascaderOnChange }));
};
export default CascaderPosition;
